// App Imports
import { API_URL, IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import params from '../../../setup/config/params'
import List from '../List'
import CreateOrUpdate from '../CreateOrUpdate'
import MediaGalleryCategoryCreateOrUpdate from '../CategoryCreateOrUpdate'
import { defaultImage } from '../../common/Sidebar'

/**
 * Image handler for MediaGallery - handles S3,  and local images
 */
export function imageMediaGallery(image = defaultImage) {
  if (!image || image === 'default.jpg') {
    return defaultImage;
  }

  // If already a complete URL (from S3), return as-is
  if (image.startsWith('https://') || image.startsWith('http://')) {
    return image;
  }
  
  // Default fallback
  return `${API_URL}/${params.mediaGallery.image.path}/${image}`;
}

/**
 * General image source handler (for non-MediaGallery images)
 */
export function getImageSource(image = defaultImage) {
  if (!image || image === 'default.jpg') {
    return defaultImage;
  }

  // If already a complete URL, return as-is
  if (image.startsWith('https://') || image.startsWith('http://')) {
    return image;
  }

  // Use IMAGE_SOURCE_PATH for general images
  return `${IMAGE_SOURCE_PATH}${image}`;
}

/**
 * Check if an image is stored in S3/
 */
export function isS3Image(imageUrl) {
  if (!imageUrl) return false;
  
  // Complete URLs are not considered for S3 processing
  if (imageUrl.startsWith('https://') || imageUrl.startsWith('http://')) {
    return false;
  }
  
  // Only relative paths starting with mediaGallery/ need processing
  return imageUrl.startsWith('mediaGallery/');
}

// Pages routes
const routes = {
  mediaGalleryList: {
    path: '/media-gallery',
    component: List,
    exact: true,
    auth: true,
    role: params.user.roles.admin.key,
    module: 'marketing',
    subModule: 'mediaGallery',
    action: 'canView'
  },
  
  mediaGalleryCreate: {
    path: '/media-gallery/create',
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: 'marketing',
    subModule: 'mediaGallery',
    action: 'canCreate'
  },
  
  mediaGalleryEdit: {
    path: (mediaGalleryId = ':mediaGalleryId') => (`/media-gallery/edit/${mediaGalleryId}`),
    component: CreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: 'marketing',
    subModule: 'mediaGallery',
    action: 'canView'
  },

  // Category routes
  mediaGalleryCategoryCreate: {
    path: '/media-gallery/category/create',
    component: MediaGalleryCategoryCreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: 'marketing',
    subModule: 'mediaGallery',
    action: 'canCreate'
  },

  mediaGalleryCategoryEdit: {
    path: (categoryId = ':categoryId') => (`/media-gallery/category/edit/${categoryId}`),
    component: MediaGalleryCategoryCreateOrUpdate,
    auth: true,
    role: params.user.roles.admin.key,
    module: 'marketing',
    subModule: 'mediaGallery',
    action: 'canEdit'
  }
}

export default routes;